/**
 * PATH: apps/ai/src/pages/openclaw-concepts/VisionSection.tsx
 * PURPOSE: "Paradigm Shift" vision cards section
 */

import { MessageSquare, Shield, Brain, Zap, ArrowRight } from 'lucide-react'

const shifts = [
  { from: 'You ask AI questions', to: 'AI tells you what matters', icon: MessageSquare, color: 'cyan' },
  { from: 'AI responds to problems', to: 'AI predicts & prevents problems', icon: Shield, color: 'green' },
  { from: 'AI forgets context daily', to: 'AI remembers & learns forever', icon: Brain, color: 'purple' },
  { from: 'AI needs explicit commands', to: 'AI takes autonomous action', icon: Zap, color: 'yellow' },
]

export function VisionSection() {
  return (
    <div className="relative py-24 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">The Paradigm Shift</h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">Moving from passive tools to active intelligence partners</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {shifts.map((shift, i) => {
            const Icon = shift.icon
            return (
              <div key={i} className="group relative">
                <div className="absolute inset-0 bg-gradient-to-r from-slate-800/50 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative p-6 rounded-2xl border border-slate-800 hover:border-slate-700 transition-colors">
                  <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl bg-${shift.color}-500/10 mb-4`}><Icon className={`w-6 h-6 text-${shift.color}-400`} /></div>
                  <div className="flex items-center gap-4">
                    <div className="flex-1"><div className="text-slate-500 text-sm mb-1">Today</div><div className="text-slate-300 line-through decoration-slate-600">{shift.from}</div></div>
                    <ArrowRight className="w-5 h-5 text-slate-600 shrink-0" />
                    <div className="flex-1"><div className={`text-${shift.color}-400 text-sm mb-1`}>Tomorrow</div><div className="text-white font-medium">{shift.to}</div></div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
